import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/LogoutDialog.css";

interface LogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onYes?: () => void;
}

const LogoutDialog: React.FC<LogoutDialogProps> = ({
  open,
  onClose,
  onYes,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "logout-dialog-container",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div>
          <div className="logout-header-container">
            <div className="logout-header-text-container">
              <div className="logout-header-container-text">Come back soon</div>
            </div>

            <div className="logout-header-container-divider"></div>
            <div className="logout-header-button-container">
              <div className="logout-header-container-button" onClick={onClose}>
                ✕
              </div>
            </div>
          </div>
          <div className="logout-divider"></div>
          <div className="logout-dialog-content">
            <p>Are you sure you want to log out?</p>
            <button className="logout-dialog-content-button" onClick={onYes}>
              Yes
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutDialog;
